export const ACCOUNT_REPORT_ID = 'account';
